module.exports = __webpack_public_path__ + "static/media/home-gallery-image7.1b66ffbe.png";